import { SubscriptionEnum } from './enums';

export class SubscriptionId {
  public static isPremium(subscriptionId: number): boolean {
    return [
      SubscriptionEnum['Glambox Premium'],
      SubscriptionEnum['Glambag Premium'],
      SubscriptionEnum['Glamcombo Premium']
    ].includes(subscriptionId);
  }

  public static isCombo(subscriptionId: number): boolean {
    return [
      SubscriptionEnum.Glamcombo,
      SubscriptionEnum['Glamcombo Premium']
    ].includes(subscriptionId);
  }

  public static isPass(subscriptionId: number): boolean {
    return subscriptionId === SubscriptionEnum.Glampass;
  }

  /**
   * Method to check if a subscriptionId is a subscription without physical products (Glampass or Prime)
   *
   * @param subscriptionId
   * @returns true if the subscriptionId is a subscription without physical products (Glampass or Prime)
   *
   */
  public static isSubscription(subscriptionId: number): boolean {
    return [SubscriptionEnum.Glampass, SubscriptionEnum.Prime].includes(
      subscriptionId
    );
  }

  public static isBag(subscriptionId: number): boolean {
    return [
      SubscriptionEnum.Glambag,
      SubscriptionEnum['Glambag Premium']
    ].includes(subscriptionId);
  }

  public static isBox(subscriptionId: number): boolean {
    return [
      SubscriptionEnum.Glambox,
      SubscriptionEnum['Glambox Premium']
    ].includes(subscriptionId);
  }
}
